export const QUEUE_TOKEN = "queueToken";
